import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';
import colors from '../Theme/colors';

interface SplitSectionProperties {
  image: ReactNode;
  content: ReactNode;
  className?: string;
}

const Section = styled.section`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  display: flex;
  flex-direction: column-reverse;
  background: ${colors.black};
  color: ${colors.white};

  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
    padding-right: 4rem;
  }
`;

const ContentPanel = styled.div`
  flex: 1 1 0;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${breakpoints.md}px) {
    padding: 4rem;
  }
`;

const ImagePanel = styled.div`
  flex: 0 0 auto;
  width: 100%;
  overflow: hidden;

  @media (min-width: ${breakpoints.md}px) {
    flex: 0 0 50%;
    width: 50%;
    aspect-ratio: 2 / 1;
    align-self: center;
  }
`;

const SplitSection = ({
  image,
  content,
  className,
}: SplitSectionProperties) => (
  <Section className={className}>
    <ContentPanel>{content}</ContentPanel>
    <ImagePanel>{image}</ImagePanel>
  </Section>
);

export default SplitSection;
